jQuery(document).ready(function ($) {
	$(".tabs").responsiveTabs({
		startCollapsed: "accordion",
	});
	$("#konnect-accordion").accordion({
		active: 0,
		collapsible: true,
		heightStyle: "content",
	});

	// Yoast FAQ Accordion Conversion
	var yoast = {
		accordion: function () {
			var isAnimating = false; // Flag variable to track animation state

			$(".wp-block-yoast-faq-block")
				.find(".schema-faq-question")
				.click(function (event) {
					event.stopPropagation(); // Stop event propagation

					if (isAnimating) {
						return; // Ignore click if animation is in progress
					}

					isAnimating = true; // Set animation flag

					var answer = $(this).nextAll(".schema-faq-answer").eq(0);

					// Expand or collapse this panel
					answer.slideToggle(250, function () {
						$(this).toggleClass("expanded");
						$(this)
							.prev(".schema-faq-question")
							.toggleClass("expanded"); // Toggle 'expanded' class on question element
						isAnimating = false; // Reset animation flag after animation completes
					});

					// Hide the other panels
					$(".schema-faq-answer").not(answer).slideUp("fast");
				});

			$(".wp-block-yoast-faq-block .schema-faq-question").click(function (
				event
			) {
				event.stopPropagation(); // Stop event propagation

				if (isAnimating) {
					return; // Ignore click if animation is in progress
				}

				isAnimating = true; // Set animation flag

				$(".wp-block-yoast-faq-block .schema-faq-question")
					.not($(this))
					.removeClass("expanded");
				$(this).toggleClass("expanded");

				isAnimating = false; // Reset animation flag
			});
		},
	};
	yoast.accordion();

	// Match Height Elements
	$(".activities-entry, .activities .vertical-divider").matchHeight();
	$(".careers-reason-headline").matchHeight();
	$(".multi-cta-text").matchHeight();
	$(".address-phone-text").matchHeight();
	$(".activities-entry h3").matchHeight();
	$(".department-content").matchHeight();
	$(".testimonial-quote").matchHeight();
	$(".location-title").matchHeight();
	$(".values-box").matchHeight();
	$(".staff-member-image, .staff-member-biography").matchHeight();

	// Responsive Tabs
	$(".gutenberg-tabs").responsiveTabs({
		startCollapsed: "accordion",
		active: 0,
	});

	// Desktop Drop down click instead of hover
	$(".main-header-menu .menu li.menu-item-has-children > a").click(function (
		e
	) {
		e.preventDefault(); // Prevent the default action
		$(this).parent().find(".sub-menu").slideToggle();
		$(this).parent().siblings().find(".sub-menu").slideUp();
		$(this).parent().toggleClass("clicked");
	});

	$(document).on("click", function (event) {
		var $trigger = $(".main-header-menu .menu li.menu-item-has-children");
		if ($trigger !== event.target && !$trigger.has(event.target).length) {
			$(".sub-menu").slideUp();
		}
	});

	// Toggle Mobile Menu
	// Toggle Mobile Menu
	$("#hamburger").on("click", function () {
		$(this).addClass("open");
		$("#mobile-menu").slideDown(300);
		$("html, body").addClass("no-scroll");
		$(".header-logo").hide();
	});
	$(".close-mobile-menu").on("click", function () {
		$("#hamburger").removeClass("open");
		$("#mobile-menu").slideUp(300);
		$("html, body").removeClass("no-scroll");
		$(".header-logo").show();
	});
	$("#mobile-menu li.has-sub > a").on("click", function () {
		$(this).removeAttr("href");
		var element = $(this).parent("li");
		if (element.hasClass("open")) {
			element.removeClass("open");
			element.find("li").removeClass("open");
			element.find("ul").slideUp();
		} else {
			element.addClass("open");
			element.children("ul").slideDown();
			element.siblings("li").children("ul").slideUp();
			element.siblings("li").removeClass("open");
			element.siblings("li").find("li").removeClass("open");
			element.siblings("li").find("ul").slideUp();
		}
	});

	// Responsive Videos
	fluidvids.init({
		selector: ["iframe", "object"], // runs querySelectorAll()
		players: ["www.youtube.com", "player.vimeo.com"], // players to support
	});

	// Smooth Scroll to Anchor
	document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
		anchor.addEventListener("click", function (e) {
			e.preventDefault();

			document.querySelector(this.getAttribute("href")).scrollIntoView({
				behavior: "smooth",
			});
		});
	});

	// Careers Modal
	$(".js-modal-btn").modalVideo();

	// Careers Filter Mobile Drop Down
	$("#alm-filter-availability-title").click(function () {
		$(".alm-filter--meta .alm-filter--inner").slideToggle();
		$(this).toggleClass("active");
	});
});
